<template>
  <b-row>
    <b-col :cols="firstColumnWidth">
      <label class="font-weight-bold">{{ label }}</label>
    </b-col>
    <b-col cols="9">
      <v-form
        ref="form"
        v-model="formValid"
      >
        <b-row
          v-for="pubContent in filteredContent"
          :key="pubContent.id + '_' + pubContent.language"
        >
          <b-col>
            <v-text-field
              v-if="canUserEdit"
              v-model="pubContent[field]"
              :label="getLang(pubContent.language)"
              :rules="rules.required"
            />

            <div v-else>
              <b>
                {{ getLang(pubContent.language) }}
              </b>
              <p v-if="pubContent[field]">
                {{ pubContent[field] }}
              </p>
              <p v-else>
                -
              </p>
              <hr>
            </div>
            <!-- Separate Error Message Component -->
            <error-message :error-message="getError(pubContent[field])" />
          </b-col>
        </b-row>
      </v-form>
    </b-col>
  </b-row>
</template>

<script>
import ErrorMessage from "./ErrorMessage.vue"; // Import the ErrorMessage component

export default {
  name: "TenantMultiLangFormSection",
  components: {
    ErrorMessage,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    model: {
      type: Array,
      default: () => [],
    },
    field: {
      type: String,
      default: "",
    },
    firstColumnWidth: {
      type: Number,
      default: 3,
    },
    required: {
      type: Boolean,
      default: false,
    },
    langFilter: {
      type: Array,
      default: () => [
        { ref: "de-CH", name: "Deutsch" },
        { ref: "fr-CH", name: "Französisch" },
        { ref: "it-CH", name: "Italienisch" },
      ],
    },
    canUserEdit: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      rules: {
        required: this.required
          ? [(value) => !!value || "Dieses Feld ist erforderlich"]
          : [() => true],
      },
      formValid: false,
    };
  },
  computed: {
    filteredContent() {
      return this.model.filter((content) =>
        this.langFilter.find((l) => l.ref === content.language),
      );
    },
  },

  mounted() {
    this.$refs.form.validate();
  },

  methods: {
    getLang(language) {
      const lang = this.langFilter.find((l) => l.ref === language);
      return lang ? lang.name : "";
    },
    getError(value) {
      if (!value && this.required) {
        return "Dieses Feld ist erforderlich";
      }
      return "";
    },
    canUniaVerantwortlicheEdit() {
      const versionData = this.$store.state.adminCurrentContract?.VersionData;
      if (versionData && versionData.ave) {
        return versionData.ave.aveState != 0 || versionData.anhang1 === true;
      }
      return false;
    },
  },
};
</script>

<style scoped></style>
